module.exports = __webpack_public_path__ + "hbomaxar-static/media/LiquidTrip_SmallLoop_00048.4ae7ad6a.png";